// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-tabbar .emeraldicons {\n  height: 16px;\n  width: 16px;\n  vertical-align: -2px;\n  margin-right: 8px;\n}\n.display-grid {\n  display: grid !important;\n}\n.emd-tabbar__link {\n  width: 100%;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
